<template>
  <div>
    <InertiaLink v-if="isProfileLinkAttached" :href="profileLink">
      <slot />
    </InertiaLink>
    <div v-else>
      <slot />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { usePermissionSystem } from '@/shared/composables/usePermissionSystem.js'

const props = defineProps({
  review: {
    type: Object,
    default: () => ({}),
  },
})

const { isUserLoggedIn } = usePermissionSystem()

const isProfileLinkAttached = computed(() => {
  return (
    props.review.authorPremiumOrMentor && props.review.isAuthorProfileComplete
  )
})

const profileLink = computed(() => {
  if (!isUserLoggedIn.value && !props.review.isAuthorMentor) {
    return '/community'
  }

  return props.review.authorProfileUrl
})
</script>
